<div class="card w-full shadow-md rounded-xl p-6 transition-colors duration-300">
  <!-- Header -->
  <div class="card-header pb-3 mb-4">
    <h4 class="text-lg font-semibold text-gray-900">User Preferences</h4>
  </div>

  <form [formGroup]="userPreferencesForm" class="space-y-6">
    <!-- Pending Transaction Screen -->
    <div class="card rounded-lg shadow-sm bg-gray-50 p-4 transition-colors">
      <div class="card-header pb-2 mb-4">
        <h5 class="font-medium text-gray-700">Pending Transaction Screen</h5>
      </div>
      <div class="space-y-4">
        <div class="flex flex-col">
          <label for="pendingRows" class="text-sm font-medium text-gray-700 mb-1">Pending Transactions Rows</label>
          <select id="pendingRows" formControlName="pendingRows"
            class="w-48 px-3 py-2 rounded-lg border-2 border-gray-300 bg-light-active text-gray-900 focus:ring-2 focus:ring-primary focus:border-primary transition-colors">
            <option [value]="10">10</option>
            <option [value]="20">20</option>
            <option [value]="50">50</option>
          </select>
        </div>

        <div class="flex flex-col">
          <label for="pendingColumnToSort" class="text-sm font-medium text-gray-700 mb-1">Pending Transactions Sort</label>
          <select id="pendingColumnToSort" formControlName="pendingSortField"
            class="w-64 px-3 py-2 rounded-lg border-2 border-gray-300 bg-light-active text-gray-900 focus:ring-2 focus:ring-primary focus:border-primary transition-colors">
            <option *ngFor="let column of pendingTransactionColumns" [value]="column.field">
              {{ column.title }}
            </option>
          </select>
        </div>

        <div class="flex flex-col">
          <label for="pendingSortDirection" class="text-sm font-medium text-gray-700 mb-1">Sort Direction</label>
          <select id="pendingSortDirection" formControlName="pendingSortDir"
            class="w-48 px-3 py-2 rounded-lg border-2 border-gray-300 bg-light-active text-gray-900 focus:ring-2 focus:ring-primary focus:border-primary transition-colors">
            <option value="asc">Ascending</option>
            <option value="desc">Descending</option>
          </select>
        </div>

        <div class="flex items-center space-x-3 p-3 bg-info-light rounded-lg border border-info">
          <input type="checkbox" id="highLightTransactionsPendingAlerts" formControlName="highLightTransactionsPendingAlerts"
            class="w-5 h-5 rounded border-2 border-gray-300 text-primary focus:ring-2 focus:ring-primary cursor-pointer">
          <label for="highLightTransactionsPendingAlerts" class="text-sm font-medium text-gray-700 cursor-pointer">
            Highlight Transactions with Pending Alerts
          </label>
        </div>
      </div>
    </div>

    <!-- Transaction Screen -->
    <div class="card rounded-lg shadow-sm bg-gray-50 p-4 transition-colors">
      <div class="card-header pb-2 mb-4">
        <h5 class="font-medium text-gray-700">Transaction Screen</h5>
      </div>
      <div class="space-y-4">
        <div class="flex flex-col">
          <label for="transactionRows" class="text-sm font-medium text-gray-700 mb-1">Transactions Rows</label>
          <select id="transactionRows" formControlName="transactionRows"
            class="w-48 px-3 py-2 rounded-lg border-2 border-gray-300 bg-light-active text-gray-900 focus:ring-2 focus:ring-primary focus:border-primary transition-colors">
            <option [value]="10">10</option>
            <option [value]="20">20</option>
            <option [value]="50">50</option>
          </select>
        </div>

        <div class="flex flex-col">
          <label for="transactionColumnToSort" class="text-sm font-medium text-gray-700 mb-1">Transactions Sort</label>
          <select id="transactionColumnToSort" formControlName="transactionSortField"
            class="w-64 px-3 py-2 rounded-lg border-2 border-gray-300 bg-light-active text-gray-900 focus:ring-2 focus:ring-primary focus:border-primary transition-colors">
            <option *ngFor="let column of transactionColumnSortOptions" [value]="column.field">
              {{ column.title }}
            </option>
          </select>
        </div>

        <div class="flex flex-col">
          <label for="transactionSortDirection" class="text-sm font-medium text-gray-700 mb-1">Sort Direction</label>
          <select id="transactionSortDirection" formControlName="transactionSortDir"
            class="w-48 px-3 py-2 rounded-lg border-2 border-gray-300 bg-light-active text-gray-900 focus:ring-2 focus:ring-primary focus:border-primary transition-colors">
            <option value="asc">Ascending</option>
            <option value="desc">Descending</option>
          </select>
        </div>

        <div class="flex flex-col">
          <label for="customTransactionStatus" class="text-sm font-medium text-gray-700 mb-1">Status for custom transaction view</label>
          <select id="customTransactionStatus" formControlName="customTransactionLinkStatus"
            class="w-64 px-3 py-2 rounded-lg border-2 border-gray-300 bg-light-active text-gray-900 focus:ring-2 focus:ring-primary focus:border-primary transition-colors">
            <option *ngFor="let status of transactionLinkStatusOptions" [value]="status.id">
              {{ status.name }}
            </option>
          </select>
        </div>

        <div class="flex flex-col">
          <label for="customTransactionDaysBack" class="text-sm font-medium text-gray-700 mb-1">Days back for custom transaction view</label>
          <select id="customTransactionDaysBack" formControlName="customTransactionLinkDaysBack"
            class="w-48 px-3 py-2 rounded-lg border-2 border-gray-300 bg-light-active text-gray-900 focus:ring-2 focus:ring-primary focus:border-primary transition-colors">
            <option [value]="5">5</option>
            <option [value]="10">10</option>
            <option [value]="15">15</option>
            <option [value]="30">30</option>
            <option [value]="45">45</option>
            <option [value]="60">60</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Account Screen -->
    <div class="card rounded-lg shadow-sm bg-gray-50 p-4 transition-colors">
      <div class="card-header pb-2 mb-4">
        <h5 class="font-medium text-gray-700">Account Screen</h5>
      </div>
      <div class="space-y-4">
        <div class="flex flex-col">
          <label for="accountRows" class="text-sm font-medium text-gray-700 mb-1">Accounts Rows</label>
          <select id="accountRows" formControlName="clientRows"
            class="w-48 px-3 py-2 rounded-lg border-2 border-gray-300 bg-light-active text-gray-900 focus:ring-2 focus:ring-primary focus:border-primary transition-colors">
            <option [value]="10">10</option>
            <option [value]="20">20</option>
            <option [value]="50">50</option>
          </select>
        </div>

        <div class="flex flex-col">
          <label for="accountColumnToSort" class="text-sm font-medium text-gray-700 mb-1">Accounts Sort</label>
          <select id="accountColumnToSort" formControlName="clientSortField"
            class="w-64 px-3 py-2 rounded-lg border-2 border-gray-300 bg-light-active text-gray-900 focus:ring-2 focus:ring-primary focus:border-primary transition-colors">
            <option *ngFor="let column of clientColumnSortOptions" [value]="column.field">
              {{ column.title }}
            </option>
          </select>
        </div>

        <div class="flex flex-col">
          <label for="accountSortDirection" class="text-sm font-medium text-gray-700 mb-1">Sort Direction</label>
          <select id="accountSortDirection" formControlName="clientSortDir"
            class="w-48 px-3 py-2 rounded-lg border-2 border-gray-300 bg-light-active text-gray-900 focus:ring-2 focus:ring-primary focus:border-primary transition-colors">
            <option value="asc">Ascending</option>
            <option value="desc">Descending</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Actions -->
    <div class="flex justify-end space-x-3 pt-4" *ngIf="userPreferencesForm.dirty">
      <button type="button" class="btn btn-light"
        (click)="onCancelUserPreferences()" [disabled]="userPreferencesForm.invalid">
        Revert Changes
      </button>
      <button type="button" class="btn btn-primary"
        (click)="onSaveUserPreferences()" [disabled]="userPreferencesForm.invalid">
        Save
      </button>
    </div>
  </form>
</div>
